import React from "react";

const svgProps = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.7,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  width: 18,
  height: 18,
};

export const IconGauge = () => (
  <svg {...svgProps}>
    <path d="M12 14l4-4M3.5 19a9 9 0 1 1 17 0" />
    <circle cx="12" cy="14" r="1.5" />
  </svg>
);

export const IconFork = () => (
  <svg {...svgProps}>
    <path d="M4 3v7a3 3 0 0 0 3 3v8M7 3v6M10 3v6M18 3c-1.5 0-3 2-3 5s1 4 1 5v8" />
  </svg>
);

export const IconWaterBottle = () => (
  <svg {...svgProps}>
    <path d="M9 2h6" />
    <path d="M10 2v2.2c0 .6-.2 1.1-.6 1.5L8.5 7.2A3 3 0 0 0 8 9.1V20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V9.1a3 3 0 0 0-.5-1.9l-.9-1.5A2 2 0 0 1 14 4.2V2" />
    <path d="M8.5 11h7" />
  </svg>
);

export const IconHeartbeat = () => (
  <svg {...svgProps}>
    <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
  </svg>
);

export const IconApple = () => (
  <svg {...svgProps}>
    <path d="M12 7c0-2 1.5-4 4-4 .5 2-1 4-4 4zM7.5 7C5 7 3 9.5 3 13c0 4 2.5 8 5 8 1 0 1.5-.5 4-.5s3 .5 4 .5c2.5 0 5-4 5-8 0-3.5-2-6-4.5-6-2 0-2.5 1-4.5 1s-2.5-1-4.5-1z" />
  </svg>
);

export const IconBook = () => (
  <svg {...svgProps}>
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20M4 19.5A2.5 2.5 0 0 0 6.5 22H20V2H6.5A2.5 2.5 0 0 0 4 4.5z" />
  </svg>
);

export const IconClock = () => (
  <svg {...svgProps}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);

export const IconWarning = () => (
  <svg {...svgProps}>
    <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
    <path d="M12 9v4M12 17h.01" />
  </svg>
);

export const IconPerson = () => (
  <svg {...svgProps}>
    <circle cx="12" cy="4.5" r="2.2" />
    <path d="M12 7v8M12 9l-5 2M12 9l5 2M12 15l-3 6M12 15l3 6" />
  </svg>
);

export const IconHeart = () => (
  <svg {...svgProps}>
    <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8z" />
  </svg>
);

export const IconPill = () => (
  <svg {...svgProps}>
    <rect
      x="3"
      y="8"
      width="18"
      height="8"
      rx="4"
      transform="rotate(-35 12 12)"
    />
    <path d="M10 10l4 4" />
  </svg>
);

export const IconList = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    width="18"
    height="18"
  >
    <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" />
  </svg>
);

export const IconPhone = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    width="12"
    height="12"
  >
    <rect x="7" y="2" width="10" height="20" rx="2.5" />
    <path d="M11 18h2" />
  </svg>
);

export const IconEyeOff = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    width="12"
    height="12"
  >
    <path d="M9.9 4.24A9.1 9.1 0 0 1 12 4c7 0 11 8 11 8a18 18 0 0 1-2.16 3.19M6.61 6.61A18 18 0 0 0 1 12s4 8 11 8a9 9 0 0 0 5.39-1.61M1 1l22 22" />
  </svg>
);

export const IconLaptop = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    width="12"
    height="12"
  >
    <rect x="3" y="4" width="18" height="12" rx="2" />
    <path d="M2 20h20" />
  </svg>
);

export const AUD_META: Record<
  string,
  { short: string; icon: React.ReactNode }
> = {
  patient: { short: "Patient Fills", icon: <IconPhone /> },
  coach: { short: "Coach Fills", icon: <IconLaptop /> },
  internal: { short: "Internal Only", icon: <IconEyeOff /> },
};

export const AudienceBadge: React.FC<{ audience: string }> = ({ audience }) => {
  const meta = AUD_META[audience];
  return (
    <span className={`aud-badge aud-${audience}`}>
      {meta?.icon}
      {meta?.short || audience}
    </span>
  );
};

const SUCCESS_SECTION_ORDER = [
  "mood",
  "motivation",
  "routine",
  "stress",
  "sleep",
  "insight",
];

const SECTION_ICON_BY_ID: Record<string, React.ReactNode> = {
  dietary_intake: <IconFork />,
  hydration: <IconWaterBottle />,
  plan_adherence: <IconGauge />,
  progress_review: <IconHeartbeat />,
  kitchen_environment: <IconApple />,
  coach_review: <IconBook />,
  ex_activity: <IconHeartbeat />,
  ex_sedentary: <IconClock />,
  ex_barriers: <IconGauge />,
  ex_pain: <IconWarning />,
  ex_fitness: <IconPerson />,
  sh_medical_history: <IconHeart />,
  sh_lifestyle_diet: <IconHeartbeat />,
  sh_lifestyle_exercise: <IconHeartbeat />,
  sh_anthro: <IconPerson />,
  sh_comorbidities: <IconWarning />,
  sh_glp1: <IconPill />,
  sh_symptoms: <IconPerson />,
};

/** Fallback when section keeps Azure/seed icon (nutrition goals, preference, goals). */
const FALLBACK_BY_BASENAME: Record<string, React.ReactNode> = {
  target: (
    <svg {...svgProps}>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" />
    </svg>
  ),
  dumbbell: (
    <svg {...svgProps}>
      <path d="M6.5 6.5v11M17.5 6.5v11M3 9.5h7M14 9.5h7M3 14.5h7M14 14.5h7" />
    </svg>
  ),
  pulse: <IconHeartbeat />,
  body: <IconPerson />,
  activity: <IconHeartbeat />,
  apple: <IconApple />,
  pill: <IconPill />,
  alert: <IconWarning />,
};

const iconBasename = (icon?: string) => {
  if (!icon) return "";
  if (!/^https?:\/\//i.test(icon)) return icon;
  const match = icon.match(/\/([^/?#]+)\.svg(?:$|[?#])/i);
  return match?.[1] || "";
};

export const successSectionNumber = (sectionId: string): number | null => {
  const idx = SUCCESS_SECTION_ORDER.indexOf(sectionId);
  return idx >= 0 ? idx + 1 : null;
};

export const sectionIcon = (
  sectionId: string,
  seedIcon?: string,
): React.ReactNode => {
  if (SECTION_ICON_BY_ID[sectionId]) return SECTION_ICON_BY_ID[sectionId];
  const base = iconBasename(seedIcon);
  if (FALLBACK_BY_BASENAME[base]) return FALLBACK_BY_BASENAME[base];
  if (seedIcon && /^https?:\/\//i.test(seedIcon)) {
    return <img src={seedIcon} alt="" width={18} height={18} />;
  }
  return <IconList />;
};
